// extracted by mini-css-extract-plugin
module.exports = {"flag":"LanguageSelectionItem_flag__mf0pP"};